export interface PasswordStrength {
  score: number
  label: string
  color: string
}

export const checkPasswordStrength = (password: string): PasswordStrength => {
  // 基于长度计算强度
  if (password.length < 8) {
    return {
      score: 1,
      label: 'weak',
      color: '#ff4d4f'
    }
  } else if (password.length < 12) {
    return {
      score: 2,
      label: 'medium',
      color: '#faad14'
    }
  } else {
    return {
      score: 3,
      label: 'strong',
      color: '#52c41a'
    }
  }
}

export const getPasswordRequirements = (password: string) => {
  const requirements = [
    {
      label: '至少8位字符',
      met: password.length >= 8
    }
  ]

  return requirements
}